import { InjectionToken } from '@angular/core';
import { environment } from 'src/environments/environment';

export namespace IframeCommunication {
  // Basing on documentation
  // https://viessmann.atlassian.net/wiki/spaces/VIG3/pages/1306755261

  export enum MessageName {
    TOKEN_EXPIRED = 'TOKEN_EXPIRED',
    NEW_TOKEN = 'NEW_TOKEN',
    REDIRECT = 'REDIRECT',
  }

  export enum MessageDataType {
    string = 'string',
    null = 'null',
  }

  export interface Message<T = unknown> {
    name: MessageName;
    data: T;
    dataType: MessageDataType;
  }

  export const IFRAME_URL = new InjectionToken<string>('');
  export const heatingSystemUrl = environment.oAuthConfig.redirectUri + 'vi-heating-systems';
}
